module.exports = __webpack_public_path__ + "static/media/Aaron_McCloud_Resume.ae6ef245.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/Aaron_McCloud_Resume.pdf
// module id = 319
// module chunks = 0